module.exports = __webpack_public_path__ + "img/7.45b47a4f.png";